import React from "react";

const TrueFalseQuestion = ({ question, answer, onAnswer }) => {
  return (
    <div className="space-y-4">
      <h2 className="font-bold text-lg text-gray-800">{question.text}</h2>
      <div className="flex gap-4">
        <label>
          <input
            type="radio"
            name={question._id}
            checked={answer === true}
            onChange={() => onAnswer(true)}
          />{" "}
          درست
        </label>
        <label>
          <input
            type="radio"
            name={question._id}
            checked={answer === false}
            onChange={() => onAnswer(false)}
          />{" "}
          نادرست
        </label>
      </div>
    </div>
  );
};

export default TrueFalseQuestion;
